/**
 * Search API client
 * Endpoint: GET /api/v2/search
 */

import { getEnv } from "@/config/env";
import { getJson, withCacheBust } from "@/api/http";
import type { SearchResult } from "@/types/search";
import type { Result } from "@/types/layout";

export interface SearchOptions {
  take?: number;
  skip?: number;
  signal?: AbortSignal;
}

export async function fetchSearchResults(
  query: string,
  options?: SearchOptions
): Promise<Result<SearchResult>> {
  const env = getEnv();
  const params = new URLSearchParams({ query });
  if (options?.take != null) params.set("take", String(options.take));
  if (options?.skip != null) params.set("skip", String(options.skip));

  const url = withCacheBust(`${env.apiBaseUrl}/search?${params.toString()}`);
  return getJson<SearchResult>(url, {
    signal: options?.signal,
  });
}
